import {
  IconFileAlert,
  IconFolders,
  IconListCheck,
  IconTimeline,
  IconWallet,
} from '@tabler/icons-react';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import { useMemo } from 'react';
import type { Menu, MenuItem } from '../types';
import { useBuildKanbanMenu } from './use-build-kanban-menu';
import { useBuildMailMenu } from './use-build-mail-menu';

export function useBuildFollowupMenu(): Menu {
  const { t } = useTranslation();
  const company = useCompanyConfiguration();
  const kanbanMenu = useBuildKanbanMenu();
  const emailMenu = useBuildMailMenu();

  return useMemo<Menu>(() => {
    const items: Array<Menu | MenuItem> = [
      kanbanMenu,
      {
        path: '/invoices/to-handle',
        label: t(i18nKeys.INVOICE_TO_PROCESS),
        Icon: IconFileAlert,
      },
      {
        path: '/thirdparty-cases',
        label: t(i18nKeys.NAV.THIRDPARTY),
        Icon: IconFolders,
      },
      {
        path: '/payment-plans',
        pathSuffix: '?status=in_progress',
        label: t(i18nKeys.NAV.PAYMENT_PLAN),
        Icon: IconWallet,
        showUpsell: !company?.package?.can_use_payment_plans,
        isExactRouteMatch: false,
      },
      {
        path: '/tasks',
        label: t(i18nKeys.NAV.TASKS),
        Icon: IconListCheck,
        showUpsell: !company?.package.can_use_tasks,
        isExactRouteMatch: false,
      },
      emailMenu,
    ];

    const menuPath = items[1].path;

    return {
      parent: null,
      label: t(i18nKeys.NAV.MY_FOLLOW_UP),
      Icon: IconTimeline,
      path: menuPath,
      items,
    };
  }, [company, emailMenu, kanbanMenu, t]);
}
